var map = {
	"./school-comp-medal-1-basic.png": 2927,
	"./school-comp-medal-2-basic.png": 2928,
	"./school-comp-medal-3-basic.png": 2929
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 375;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ranks .\.png*
// module id = 375
// module chunks = 0